import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { STATE_STYLES, relativeTime } from "@/lib/format";
import { api, formatApiError } from "@/api";
import { toast } from "sonner";

export function ActiveAlertsBanner({ sensors, onAck }) {
  // Gather active+unacked alerts from /api/sensors payload
  const items = [];
  (sensors || []).forEach((s) => {
    (s.active_alerts || []).forEach((a) => {
      if (!a.ack_at) {
        items.push({
          ...a,
          sensor_id: s.id,
          sensor_name: s.name,
        });
      }
    });
  });

  if (items.length === 0) return null;

  return (
    <div className="mb-6 space-y-2" data-testid="active-alerts-banner">
      {items.map((a) => {
        const style = STATE_STYLES[a.severity];
        return (
          <div
            key={a.id}
            data-testid={`active-alert-${a.id}`}
            className={`border-l-4 ${style.border} ${style.bg} p-4 flex items-center justify-between gap-4`}
          >
            <div>
              <div className="flex items-center gap-3 mb-1">
                <span
                  className={`text-xs uppercase tracking-widest border px-2 py-0.5 ${style.pill}`}
                >
                  {style.label}
                </span>
                <span className="font-display text-lg font-bold uppercase tracking-tight">
                  {a.sensor_name}
                </span>
              </div>
              <div className="text-xs text-zinc-400">
                Opened {relativeTime(a.opened_at)} ·{" "}
                <Link
                  to="/alerts"
                  className="underline hover:text-zinc-200"
                  data-testid={`active-alert-link-${a.id}`}
                >
                  view all
                </Link>
              </div>
            </div>
            <Button
              onClick={async () => {
                try {
                  await api.post(`/alerts/${a.id}/ack`);
                  toast.success("Alert acknowledged");
                  onAck?.();
                } catch (err) {
                  toast.error(formatApiError(err));
                }
              }}
              data-testid={`active-alert-ack-${a.id}`}
              className="rounded-sm bg-zinc-100 text-zinc-950 hover:bg-white uppercase tracking-widest text-xs font-bold"
            >
              Acknowledge
            </Button>
          </div>
        );
      })}
    </div>
  );
}
